import React from 'react';
import MissionDetail from './MissionDetail';
import missionsData from '../data/missions.json';

function MissionCommunityHelpline() {
  return <MissionDetail mission={missionsData.communityHelpline} />;
}

export default MissionCommunityHelpline;
